import LinksContent from './widgets/LinksContent';
import LinksHeader from './widgets/LinksHeader';

const LinksListPage = () => {
  return (
    <div>
      <LinksHeader />
      <LinksContent />
    </div>
  );
};

export default LinksListPage;
